const { version } = require('../../package.json');

/* eslint-disable */
// import registration.js to ensure code gets executed
import {} from './shared';
import {} from './registration-screen';
import {} from './profile-screen';
import {} from './identifier-screen';
import {} from './regpac-screen';

console.log(`******** AIB javascript Version: ${version} ******** `);

const aib = window.aib;
console.log('window.aib', aib);
/* eslint-enable */

// Inject the version onto the screen to ensure correct version is deployed
const elements = document.getElementsByClassName('ping-template-version-javascript');
for (let i = 0; i < elements.length; i += 1) {
  const element = elements[i];
  element.innerHTML = version;
}
